module.exports = __webpack_public_path__ + "static/media/sidebar-create-school-active.1f92d54a.svg";